import { setActiveCustomerTab } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import { getData } from '@/services/api.service';
import { routePrefix, routes } from '@/utils/routes/routes';
import React, { useEffect, useState } from 'react';
import { MdMenu, MdArrowDropDown, MdKeyboardArrowDown } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';

const MenuHeader = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [categories, setCategories] = useState<any[]>([]);
  const header = useSelector((state: RootState) => state.common.header);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData(`categories?type=service`);
        if (response.status === 200 || response.status === 201) {
          setCategories(response?.data?.data?.all_categories);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="category-menus">
      <div className="container">
        <div className="row align-items-center">
          {/* Category Sidebar */}
          <div className="col-md-3 d-none d-lg-flex d-xl-flex">
            <div className="category-list">
              <ul>
                <li
                  className={`has-dropdown ${isDropdownOpen ? 'open' : ''}`}
                  onMouseEnter={() => setDropdownOpen(true)}
                  onMouseLeave={() => setDropdownOpen(false)}
                >
                  <button className="category-button">
                    <MdMenu size={20} />
                    Categories
                    <MdKeyboardArrowDown
                      size={24}
                      style={{
                        marginLeft: 'auto',
                        transition: 'transform 0.3s ease',
                        transform: isDropdownOpen
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      }}
                    />
                  </button>

                  <ul
                    className={`dropdown sidebar ${isDropdownOpen ? 'show' : ''}`}
                  >
                    {categories?.map((category) => (
                      <li key={category?.id}>
                        <Link
                          to={`${routePrefix}/category/${category?.id}`}
                          onClick={() => {
                            dispatch(setActiveCustomerTab(category.name));
                          }}
                        >
                          <img
                            src={`${category?.image_path}`}
                            alt={category?.slug}
                          />{' '}
                          <span>{category.name}</span>
                        </Link>
                      </li>
                    ))}
                    <li className="px-3 mt-2">
                      <Link
                        to={routes?.all_category}
                        onClick={() => {
                          dispatch(setActiveCustomerTab('Shop'));
                        }}
                        className="button style3 text-center"
                      >
                        All Categories
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          {/* Main Navigation */}
          <div className="col-md-9">
            <div className="main-header-inner">
              <div id="main-menu" className="main-menu">
                <nav id="mobile-nav" className="d-flex justify-content-between">
                  <ul>
                    {header?.headers?.map((data: any) => {
                      if (data?.slug == '#') return;
                      return (
                        <li>
                          <Link
                            to={`${data?.slug == '#' ? '#' : routePrefix + '/' + data?.slug}`}
                          >
                            {data?.title}
                          </Link>
                        </li>
                      );
                    })}
                    <li>
                      <Link to={routes.pricing}>Pricing</Link>
                    </li>
                  </ul>

                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MenuHeader);
